import { render, staticRenderFns } from "./UserPhoto.vue?vue&type=template&id=5fd19f30&scoped=true&"
import script from "./user-photo.js?vue&type=script&lang=js&"
export * from "./user-photo.js?vue&type=script&lang=js&"
import style0 from "./user-photo.scss?vue&type=style&index=0&id=5fd19f30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd19f30",
  null
  
)

export default component.exports